import { ActionType, TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { Card, Stack, Typography } from '@optimus-web/core';
import { IconName } from '@optimus-web/icons';
import { PaymentDetailResult } from '@mews-commander/data-access';
import { ModalSidePanel } from '../../../../../components';
import { HeadingAction } from '../../../../../legacy/React/Components/HeadingAction/Action/types';
import ActionMenu from '../../../../../legacy/React/Components/HeadingAction/ActionMenu';
import { renderDetailEntries, getPaymentDetailsEntries, renderReceiptEntries } from './util';
import { useGetPaymentDetails } from './queries';
import { usePrintSettings } from './hooks';

interface PaymentDetailsSidebarProps {
    paymentId: string;
    isOpen: boolean;
    closeDialog: () => void;
}
interface PaymentDetailsSidebarContentProps {
    data: PaymentDetailResult;
}
const PaymentDetailsSidebarContent = ({ data }: PaymentDetailsSidebarContentProps) => {
    const { details, receipt } = data;
    return (
        <Stack vertical spacing="200">
            <Card padding="200">
                <Stack vertical spacing="100">
                    {renderDetailEntries(getPaymentDetailsEntries(details))}
                </Stack>
            </Card>
            {receipt && (
                <Card padding="200">
                    <Stack vertical spacing="200">
                        <Stack vertical spacing="100">
                            {renderReceiptEntries(receipt.receiptData)}
                        </Stack>
                    </Stack>
                </Card>
            )}
        </Stack>
    );
};

export const PaymentDetailsSidebar = ({ isOpen, closeDialog, paymentId }: PaymentDetailsSidebarProps) => {
    const { data, isFetching } = useGetPaymentDetails({ paymentId });
    const title = data?.details?.title;
    const printSettings = usePrintSettings({ paymentId });

    const actions: HeadingAction[] = [
        {
            ...printSettings,
            type: ActionType.Print,
            text: <LocalizedText textKey={TextKey.Print} />,
            icon: IconName.Print,
            disabled: false,
        },
    ];

    return (
        <ModalSidePanel
            loading={isFetching}
            opened={isOpen}
            title={
                <Typography textStyle="titleMediumStrong" as="div">
                    {title}
                </Typography>
            }
            onClose={closeDialog}
            width="small"
            //  @ts-expect-error $TSFixMeError: JSX element type 'ActionMenu' does not have any construct or call signatures.
            headerActions={<ActionMenu actions={actions} />}
            content={data ? <PaymentDetailsSidebarContent data={data} /> : null}
        />
    );
};
